import { CDN_ENDPOINT, CDN2_ENDPOINT } from 'config/vars'
import urlJoin from 'utils/url-join'

const DEFAULT_BUCKET = 'files.arvoredelivros.com.br'
const DEFAULT_BUCKET_2 = 'arvore'

export function getImageUrl(imageName) {
  return getAssetUrl(`arvore-library-assets/images/${imageName}`)
}

export function getVideoUrl(videoName) {
  return getAssetUrl(`arvore-library-assets/videos/${videoName}`)
}

export function getLottieAnimation(lottiePath) {
  return getAssetUrl(`arvore-library-assets/lottie/${lottiePath}`)
}

export function getAssets3dUrl(pathName) {
  return getAssetUrl(`otto3d/${pathName}`)
}

export function getAssetUrl(path, bucket = DEFAULT_BUCKET) {
  return urlJoin(`${CDN_ENDPOINT}/${bucket}`, path)
}

export function getAssetUrl2(path, bucket = DEFAULT_BUCKET_2) {
  return urlJoin(`${CDN2_ENDPOINT}/${bucket}`, path)
}

export function getAudioUrl(audioName) {
  return getAssetUrl(`arvore-library-assets/audios/${audioName}`)
}

export default {
  getImageUrl,
  getAssetUrl,
  getLottieAnimation,
  getAssets3dUrl,
  getAssetUrl2,
  getAudioUrl,
  getVideoUrl
}
